module.exports = __webpack_public_path__ + "assets/img/doc_nfc_app_created.e4a3a2cd.png";